import { Box, Typography } from '@material-ui/core'

export interface SquareButtonProps {
  image?: JSX.Element
  text: string
  type: string
  icon?: string
  handleClick: () => void
}

export const SquareButton = ({
  image,
  text,
  type,
  icon,
  handleClick,
}: SquareButtonProps): JSX.Element => {
  return (
    <Box
      className={type === 'primary' ? 'squareButtonPrimary' : 'squareButtonSecondary'}
      onClick={handleClick}
    >
      <Box>
        <Box>{image ? image : <i className={icon}></i>}</Box>
        <Typography className="bodyFont">
          <b>{text}</b>
        </Typography>
      </Box>
    </Box>
  )
}
